module.exports = __webpack_public_path__ + "static/media/higuchi-building-5.6aab6948.jpg";